// extracted by mini-css-extract-plugin
module.exports = {"categoryFaq":"categoryFAQ_categoryFaq__Vs6yK","active":"categoryFAQ_active__oIOgw"};